const env = import.meta.env

const backendBase = env.VITE_API_BACKEND_BASE
const envType = env.VITE_API_ENV || "preview"

const getServerUrl = (service: string, env: string) => {
    return `https://${service}-server-${env}.${backendBase}`
}

const getBaseUrl = () => {
    if (env.BASE_URL) {
        return env.BASE_URL
    }

    return `https://${window.location.host}`
}

function getAuthDomain() {
    return window.location.host
}

const authDomain = getAuthDomain()

export const CONFIGURATION = {
    version: "0.0.1",
    type: envType,
    BASE_URL: getBaseUrl(),
    endpoints: {
        zeno: getServerUrl("zeno", envType),
        studio: getServerUrl("studio", envType),
    },
    API_PATH: `/api/v1`,
    firebase: {
        apiKey: env.VITE_FIREBASE_API_KEY,
        authDomain,
        projectId: "dengenlabs",
        providerType: "google",
    },
}
